import { ROUTE_SINGLE_CANCER_VIEW } from '@/constants/routes';
import { formatCancerTypeNameWithCapitalization } from '@/utils';
import { RouteObject } from 'react-router-dom';
import Page from './single-cancer-view.page';

export const routeSingleCancerView: RouteObject = {
  path: ROUTE_SINGLE_CANCER_VIEW,
  Component: Page,
  loader: ({ params }) => {
    document.title = `${formatCancerTypeNameWithCapitalization(params.cancerId ?? '')} Cancer`;
    return null;
  },
};
